module.exports = __webpack_public_path__ + "static/media/6_School of the animals_RU.214c3342.txt";